import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../Buttons/ButtonCinestar/ButtonCinestar'

import './BasketPriceReserve.scss'

const BasketPriceReserve = ({ onReserve, loading, amount, currency, className }) => {
    const intl = useIntl()

    return (
        <>
            <ButtonCinestar
                variant={'outlined'}
                className={'bg-white d-flex gap-1'}
                onClick={onReserve}
                disabled={loading}
            >
                {intl.formatMessage(
                    { id: 'basket.reserveBtn' },
                    { span: (chunks) => <span className="d-none d-lg-flex text-nowrap">{chunks}</span> }
                )}
            </ButtonCinestar>
        </>
    )
}

export default BasketPriceReserve
